import { Flex, Text } from "@chakra-ui/react";
import Badge from "../Badge";
import { getCommandPriorityBadgeValue } from "./getCommandPriorityBadgeValue";

function CommandPriorityBadge() {
	const badge = getCommandPriorityBadgeValue();

	return (
		<Badge
			w="fit-content"
			h={badge.height}
			fontSize="14px"
			fontWeight={500}
			px="12px"
			borderRadius={badge.borderRadius}
			backgroundColor={badge.backgroundColor}
			color={badge.textColor}
			textAlign="center"
			whiteSpace="nowrap"
			display="flex"
			flexDirection="row"
			alignItems="center"
		>
			<Flex direction="row" alignItems="center">
				<Text whiteSpace="nowrap">{badge.label}</Text>
			</Flex>
		</Badge>
	);
}

export default CommandPriorityBadge;
